var map = {
	"./caiwukuaiji.svg": 1060,
	"./caiziguanli.svg": 1061,
	"./default.svg": 1062,
	"./dongtaijianmopingtai.svg": 1063,
	"./gongxiangfuwu.svg": 1064,
	"./gongyinglian.svg": 1065,
	"./guanlikuaiji.svg": 1066,
	"./jichengpingtai.svg": 1067,
	"./jichushezhi.svg": 1068,
	"./richangcaozuo.svg": 1069,
	"./wodezuoye.svg": 1070,
	"./yingyongguanlipingtai.svg": 1071,
	"./yusuanbaobiao.svg": 1072,
	"./zichanguanli.svg": 1073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1059;